import { Injectable, OnInit, OnDestroy } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import {QuickDeligation, recentDelegatee,addRequest, addAdvanceRequest, OnBehalfEmployee, DelegateAppId} from './quick-delegation';
import { Observable, throwError } from 'rxjs';
import { Globals } from 'src/app/_utlity/globals';
import { GlobalService } from 'src/app/_services/CommonServices/global.service';
import { catchError, map } from 'rxjs/operators';
import { AppInsightsService } from 'src/app/_services/ReportServices/app-insights.service';
import { SAPID } from 'src/app/_shared/common/global-variables';
import { AppId } from 'src/app/_shared/common/global-variables';
import { Console } from 'console';
//import { analyzeAndValidateNgModules } from '@angular/compiler';

@Injectable({
  providedIn: 'root'
})
export class QuickDeligationService implements OnInit,OnDestroy{

  constructor(private global: GlobalService,private httpClient:HttpClient, private globals:Globals,private appInsights:AppInsightsService,private globalServices: GlobalService) { }
 
  private SapId = this.global.UserLoggedInSAPID;
  private AppId = localStorage.getItem("AppId");
  num:any;
  private fetchApplicationUrl='DelegationRequest/GetQuickDelegationDetails/';
  private fetchRecentDelegateeUrl='DelegationRequest/GetDelegateeDetails/';
  private fetchDelegateeSuggestionsUrl='DelegationRequest/SearchDelegatee/';
  private addDelegationReqUrl='DelegationRequest/AddRequest';
  private OnBehalfValidationCheck='DelegationRequest/OnBehalfValidationCheck';
  private AddOnBehalfRequest='DelegationRequest/AddOnBehalfRequest';
  private GetOnbehalfDelegationDetails='DelegationRequest/GetOnbehalfDelegationDetails'
  private GetOnbehalfExceptionalDelegationDetails='DelegationRequest/GetOnbehalfExceptionalDelegationDetails'
  private GetOnBehalfAppWiseDelegation='DelegationRequest/GetOnBehalfAppWiseDelegation'
  private fetchIntegratedAppUrl='Delegation/GetAllActiveApplications'
  private GetAppsBasedOnAppIandUserIdRoleandSubRoles='Delegation/GetAppsDelegationRoleandSubRoles'
  ngOnInit()
  {  
    //this.fetchApplications();
    this.fetchRecentDelegatee();  
  }
  ngOnDestroy()
  { }
  sapId:SAPID;
  appId:AppId;
  fetchApplications():Observable<QuickDeligation[]>
  {
    this.SapId=this.global.UserLoggedInSAPID;
    const sapId = <SAPID>
    {
      ReqSAPID:this.SapId
    }
    const httpHeaders = new HttpHeaders({
                          });
    return this.httpClient.post<QuickDeligation[]>(this.globalServices.baseUrl + this.fetchApplicationUrl, sapId,{headers:httpHeaders});
  }
  
  fetchRecentDelegatee():Observable<recentDelegatee[]>
  {
    this.SapId=this.global.UserLoggedInSAPID;
    const sapId = <SAPID>
    {
      ReqSAPID:this.SapId
    }
    const httpHeaders = new HttpHeaders({
                          });
    return this.httpClient.post<recentDelegatee[]>(this.globalServices.baseUrl + this.fetchRecentDelegateeUrl, sapId,{headers:httpHeaders});
  }

  fetchDelegateeSuggestions(sapid:SAPID):Observable<recentDelegatee[]>
  {
    const httpHeaders = new HttpHeaders({  
                                });
      return this.httpClient.post<recentDelegatee[]>(this.globalServices.baseUrl+ this.fetchDelegateeSuggestionsUrl, sapid,{headers:httpHeaders});
  }
  

  addDelegationRequest(addRequest : addRequest[]):Observable<any>
  {
    this.appInsights.logEvent('addDelegation',addRequest);
    const httpHeaders = new HttpHeaders({
                                'Content-Type':'application/json'
                              });
    return this.httpClient.post<any>(this.globalServices.baseUrl+this.addDelegationReqUrl,addRequest,{headers:httpHeaders})
    .pipe(
      map((data: any) => {
        //console.log(data);
        return data;
      }),
      catchError(this.handleError)
    );
  }

  addOnBehalfDelegationRequest(addRequest : addAdvanceRequest[]):Observable<any>
  {
    this.appInsights.logEvent('addDelegation',addRequest);
    const httpHeaders = new HttpHeaders({
                                'Content-Type':'application/json'
                              });
    return this.httpClient.post<any>(this.globalServices.baseUrl+this.AddOnBehalfRequest,addRequest,{headers:httpHeaders})
    .pipe(
      map((data: any) => {
        //console.log(data);
        return data;
      }),
      catchError(this.handleError)
    );
  }
  OnBehalfDelegationValidate(addRequest : addAdvanceRequest[]):Observable<any>
  {
    
    this.appInsights.logEvent('addDelegation',addRequest);
    const httpHeaders = new HttpHeaders({
                                'Content-Type':'application/json'
                              });
    return this.httpClient.post<any>(this.globalServices.baseUrl+this.OnBehalfValidationCheck,addRequest,{headers:httpHeaders})
    .pipe(
      map((data: any) => {
        //console.log(data);
        return data;
      }),
      catchError(this.handleError)
    );
  }

  addAdvanceDelegationRequest(addAdvanceRequest:addAdvanceRequest[]):Observable<any>
  {
    this.appInsights.logEvent('addAdvanceDelegation',addAdvanceRequest);
    const httpHeaders = new HttpHeaders({
      'Content-Type':'application/json'

           });
          return this.httpClient.post<any>(this.globalServices.baseUrl+this.addDelegationReqUrl,addAdvanceRequest,{headers:httpHeaders})
          .pipe(
          map((data: any) => {
          return data;
        }),
        catchError(this.handleError)
        );
    }
    fetchAppOnBehalfDelegation(SearchEmp:any):Observable<OnBehalfEmployee[]>
    {      
      this.SapId=this.global.UserLoggedInSAPID;
      this.num=SearchEmp;
      const sapId = <SAPID>
      {
        ReqSAPID:this.num.ReqSAPID,
        LoginSapId:this.SapId,
        ReqAppid:this.num.ReqAppid
        
      }
      //console.log("sapId",sapId)
      this.appInsights.logEvent('fetchAppOnBehalfDelegation');
      const httpHeaders = new HttpHeaders({
                            'Content-Type':'application/json'
                          });
      return this.httpClient.post<any>(this.globalServices.baseUrl+this.GetOnBehalfAppWiseDelegation,sapId,{headers:httpHeaders})
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError(this.handleError)
      );
    }

   handleError(err: HttpErrorResponse){
    let errorMessage='';
    if (err.error instanceof ErrorEvent) 
    {
      errorMessage = `An error occurred : ${err.error.message}`;
    }
    else 
    {
      errorMessage=`Server returned code: ${err.status}, errorMessage is : ${err.message}`;
    }
    //console.error(errorMessage);
    return  throwError(errorMessage);
  }
  fetchExceptioanlAccessApplications():Observable<QuickDeligation[]>
  {
    this.SapId=this.global.UserLoggedInSAPID;    
    const sapId = <SAPID>
    {
      ReqSAPID:this.SapId,
      LoginSapId:this.SapId
    }
    const httpHeaders = new HttpHeaders({
                          });
    return this.httpClient.post<QuickDeligation[]>(this.globalServices.baseUrl + this.GetOnbehalfExceptionalDelegationDetails, sapId,{headers:httpHeaders});
  }
  //Adde by Gopi 

  GetActiveApplications():Observable<[]>
  {
    const httpHeaders = new HttpHeaders({
                          });
    return this.httpClient.get<[]>(this.globalServices.baseUrl + this.fetchIntegratedAppUrl,{headers:httpHeaders});
  }

  GetAppsDelegationRoleandSubRoles(delegatorId:DelegateAppId):Observable<recentDelegatee[]>
  {
    const httpHeaders = new HttpHeaders({
                                });
      return this.httpClient.post<recentDelegatee[]>(this.globalServices.baseUrl+ this.GetAppsBasedOnAppIandUserIdRoleandSubRoles, delegatorId,{headers:httpHeaders});
  }
}



